import { formatMoneyKr } from '../../utils';
import styles from './product-price-and-earning-info.module.less';

export const ProductPriceAndEarningInfo = ({ product, options = {} }) => {
    const { pricingData } = product;
    const { showEarnings } = options;

    const earning =
        pricingData.salePrice - (pricingData.fee + pricingData.salePrice * pricingData.transactionFeePercentage);

    return (
        <div className={styles.saleWrapper}>
            <span className={styles.salePrice}>
                {showEarnings && <span>Selges for: </span>}
                <span className={styles.salePriceValue}>{formatMoneyKr(pricingData.salePrice)}</span>
            </span>
            {showEarnings && (
                <span>
                    Dere tjener:{' '}
                    <span className={styles.salePriceValue}>
                        {formatMoneyKr(earning, earning !== Math.floor(earning))}
                    </span>
                </span>
            )}
        </div>
    );
};
